const READY_ORDER_BLOCK_DATA = {
  title: 'Ready to order?',
  titleMobile: 'Ready to order?',
  leftImage: '',
  leftImageMobile: '',
  rightImage: '',
  rightImageMobile: '',
  leftStripes: [
    {
      id: 1,
      text: '',
      color: '#293241',
      colorText: '#ECC486',
    },
    {
      id: 2,
      text: 'place an order online',
      textMob: 'place an order online',
      color: '#ECC486',
      colorText: '#293241',
      link: '',
    },
  ],
  rightStripes: [
    {
      id: 1,
      text: '',
      color: '#D7E8F0',
      colorText: '#5F8AA4',
    },
    {
      id: 2,
      text: 'talk to our team',
      textMob: 'talk to our team',
      color: '#5F8AA4',
      colorText: '#fff',
      link: '',
    },
  ],
  isPod: false,
  bottomMode: 'phone', // 'phone' or 'description'
  bottomText: 'TALK TO A',
  bottomTextMobile: 'YES, YOU ACTUALLY CAN TALK TO A',
  bottomTextBold: 'REAL PERSON!',
  bottomTextBoldMobile: 'REAL PERSON!',
  phoneNumber: '800-916-6076',
  bottomDescription: '',
  bottomDescriptionMobile: '',
  reviewsCount: 2717,
};

export default READY_ORDER_BLOCK_DATA;
